import { useAppSelector } from '../hooks/useAppSelector';
import * as referenceSlice from '../data/reference.slice';

export const useLegalEntityType = (typeId: number | undefined): string => {
  const types = useAppSelector(referenceSlice.selectLegalEntityTypes);
  const type = types.find((t) => t.legalEntityTypeID === typeId);
  return type ? type.legalEntityTypeName : '';
};
